import { defineComponent as _defineComponent } from 'vue';
import {} from "./JobStateSummary";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CollectionProgress',
    props: {
        summary: null
    },
    setup(__props) {
        return { __sfc: true, };
    }
});
